'use client';

import type { FormFieldProps, FormType } from '../../types/types';

import { Field } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

export const FormField = <T extends FormType>(
	props: FormFieldProps<T>,
) => {
	const {
		label,
		name,
		children,
		helperText,
		optionalText,
		...rest
	} = props;
	const { formState } = useFormContext<T>();
	const errorText = formState.errors[name]?.message as string | undefined;

	return (
		<Field.Root invalid={Boolean(errorText)} {...rest}>
			{label && (
				<Field.Label>
					{label}
					<Field.RequiredIndicator fallback={optionalText} />
				</Field.Label>
			)}
			{children}
			{helperText && <Field.HelperText textStyle={'p4'}>{helperText}</Field.HelperText>}
			{errorText && <Field.ErrorText textStyle={'p4'}>{errorText}</Field.ErrorText>}
		</Field.Root>
	);
};